window.addEventListener('scroll', function () {
      if (window.scrollY > 1) {
            document.querySelector('header').classList.add('sticky');
      } else {
            document.querySelector('header').classList.remove('sticky');
      }
});

document.addEventListener('DOMContentLoaded', function () {
      if (window.location.hash) {
            var hash = window.location.hash.slice(1);
            var target = document.querySelector('[data-scroll-id="' + hash + '"]');

            if (target) {
                  window.scrollTo({
                        top: target.getBoundingClientRect().top + window.pageYOffset - 200,
                        behavior: 'smooth'
                  });
            }
      }
});

document.addEventListener("DOMContentLoaded", function () {
      document.querySelector(".copy-link").addEventListener("click", function () {
            var tempInput = document.createElement("input");
            tempInput.value = this.getAttribute("data-url");
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);

            // Get translated text from data-message attribute
            var copiedText = this.getAttribute("data-message") || "Copied!";

            // Create popup
            var popup = document.createElement("div");
            popup.textContent = copiedText;
            popup.classList.add("copy-popup");

            // Append popup to body and position it near the button
            document.body.appendChild(popup);
            var rect = this.getBoundingClientRect();
            popup.style.top = `${rect.top + window.scrollY - 40}px`;
            popup.style.left = `${rect.left + rect.width / 2 - 40}px`;

            // Show animation, then remove after 1.5 seconds
            setTimeout(() => {
                  popup.classList.add("fade-out");
                  setTimeout(() => popup.remove(), 500);
            }, 1500);
      });
});

